import { type EffortLevel, isEffortLevel } from "../../shared/aiProviders";

type EffortEntry = {
  entryType: string;
  userMessage?: { effort?: string | null } | null;
};

export function resolveEffortFromEntries(
  entries: readonly EffortEntry[]
): EffortLevel | null {
  const latestUserIndex = entries.findLastIndex(
    (entry) => entry.entryType === "UserMessage" && entry.userMessage
  );
  const effort =
    latestUserIndex >= 0 ? entries[latestUserIndex]?.userMessage?.effort : null;
  return isEffortLevel(effort) ? effort : null;
}

function effortStorageKey(chatId: string) {
  return `chat-effort:${chatId}`;
}

export function loadEffort(chatId: string | null): EffortLevel | null {
  if (!chatId) return null;
  try {
    const value = localStorage.getItem(effortStorageKey(chatId));
    return isEffortLevel(value) ? value : null;
  } catch {
    return null;
  }
}

export function saveEffort(chatId: string | null, effort: EffortLevel | null) {
  if (!chatId) return;
  try {
    if (effort) localStorage.setItem(effortStorageKey(chatId), effort);
    else localStorage.removeItem(effortStorageKey(chatId));
  } catch {}
}

export function effortLabel(effort: EffortLevel | null): string {
  if (!effort) return "Provider default";
  return effort.charAt(0).toUpperCase() + effort.slice(1);
}
